    <iframe
        [src]="chatMessageNumberUrl"
        *ngIf="chatModuleEnabled"
        #iframe
        frameBorder="0"
        ></iframe>
